export default __webpack_public_path__ + "static/media/arconnect-logo.a8083f05.svg";